import { EmploymentTypeProvider } from '../../components/Providers'
import Person from '../Person'

export default function Student() {
  return (
    <EmploymentTypeProvider type="student">
      <Person />
    </EmploymentTypeProvider>
  )
}
